module.exports = __webpack_public_path__ + "components/flag/static/square/lr-e5f0e2faf2be6a478755dbcff2a54e97.svg";